import { ExecutionHistoryList } from './ExecutionHistoryList';

/**
 * History tab content for the automation editor
 * Shows the execution history list for the automation
 */
export const HistoryTabContent = () => (
  <div className="@HistoryTabContent h-full">
    <ExecutionHistoryList />
  </div>
);
